import React from "react";
import MenuItem from "./MenuItem";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoIosGitCompare } from "react-icons/io";
import { MdOutlineAccountBalance } from "react-icons/md";
import { GoArchive } from "react-icons/go";
import { IoAddCircleOutline } from "react-icons/io5";
import { IoNewspaperOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineAttachMoney } from "react-icons/md";
import MediaQuery from "react-responsive";

class Menu extends React.Component {
    constructor() {
        super();
        this.state = {
            indexClicked: 1
        };
    }

    render() {
        const itemSelected = (index) => {
            this.setState({
                indexClicked: index
            });
        };

        return (
            <MediaQuery maxWidth="599px">
                {(isMobile) => {
                    return (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                background: "white",
                                height: isMobile ? "100px" : "64px",
                                textAlign: "center",
                                borderTopWidth: "1px",
                                borderTopStyle: "solid"
                            }}
                        >
                            <MenuItem
                                link={"/content/approval"}
                                description={"אישור פעולות"}
                                index={1}
                                icon={IoIosCheckmarkCircleOutline}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            />
                            {/* <MenuItem
                                link={"/content/balance"}
                                description={"מאזן"}
                                index={2}
                                icon={MdOutlineAccountBalance}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                            /> */}
                            <MenuItem
                                link={"/content/monthSummary"}
                                description={"סיכום חודשי"}
                                index={9}
                                icon={HiOutlineDocumentReport}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            />
                            {!isMobile && (
                                <MenuItem
                                    link={"/content/budgetStatus"}
                                    description={"תקציב"}
                                    index={3}
                                    icon={MdOutlineAttachMoney}
                                    itemSelected={itemSelected}
                                    selectedIndex={this.state.indexClicked}
                                />
                            )}
                            {!isMobile && (
                                <MenuItem
                                    link={"/content/monthCompare"}
                                    description={"השוואה"}
                                    index={4}
                                    icon={IoIosGitCompare}
                                    itemSelected={itemSelected}
                                    selectedIndex={this.state.indexClicked}
                                />
                            )}
                            <MenuItem
                                link={"/content/archive"}
                                description={"ארכיון"}
                                index={5}
                                icon={GoArchive}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            />
                            <MenuItem
                                link={"/content/addTransaction"}
                                description={"הוספת פעולה"}
                                index={6}
                                icon={IoAddCircleOutline}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            />
                            <MenuItem
                                link={"/content/management"}
                                description={"ניהול"}
                                index={7}
                                icon={IoNewspaperOutline}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            />
                            {!isMobile && (
                                <MenuItem
                                    link={"/content/configuration"}
                                    description={"הגדרות תקציב"}
                                    index={8}
                                    icon={IoSettingsOutline}
                                    itemSelected={itemSelected}
                                    selectedIndex={this.state.indexClicked}
                                    width={"100px"}
                                />
                            )}
                            {/* <MenuItem
                                link={"/content/logs"}
                                description={"logs"}
                                index={8}
                                icon={IoNewspaperOutline}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            /> */}
                            {/* <MenuItem
                                link={"/content/playground"}
                                description={"playground"}
                                index={8}
                                icon={IoNewspaperOutline}
                                itemSelected={itemSelected}
                                selectedIndex={this.state.indexClicked}
                                width={"100px"}
                            /> */}
                        </div>
                    );
                }}
            </MediaQuery>
        );
    }
}

export default Menu;
